// lib
import { connect } from "react-redux";
import * as R from "ramda";
// src
import { PresetType } from "config/constants";
import Component from "components/modals/favorites/Favorites";
import { injectIndex, strictJoin } from "utils/presets";
import { hideFavorites } from "actions/ux";
import { updateAndPatchFavorites } from "actions/presets/thunks";
import { selfTranslate } from "i18n/proxy";

// Sort like vertical ordering (index of fav in 1st cat is smaller than 2nd cat)
const sortFavorites = (presets) => {
  const { floor = [], categories = [], ...children } = R.groupBy(({ type, underId }) => {
    if (type === PresetType.CATEGORY) return "categories";
    if (!underId) return "floor";
    return underId;
  }, presets);

  return R.reduce(
    (acc, category) => {
      const catChildren = (children && children[category.id]) || [];
      return R.concat(acc, [category, ...catChildren]);
    },
    floor,
    categories,
  );
};

const mapStateToProps = ({ ux: { isFavoritesOpen, isSmall }, presets: { byId, favoriteIds } }) => {
  const unsortedFavs = strictJoin(byId, favoriteIds).map((preset) => ({
    ...preset,
    name: selfTranslate(preset.name),
  }));
  const favorites = injectIndex(sortFavorites(unsortedFavs));
  return {
    favorites,
    isFavoritesOpen,
    isSmall,
  };
};

const mapDispatchToProps = {
  hideFavorites,
  updateAndPatchFavorites,
};

export default connect(mapStateToProps, mapDispatchToProps)(Component);
